module.exports = __webpack_public_path__ + "static/1-asset-1-d@2x-dacf02a35e4355c8cac53dbf1c14f83f.png";